import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import store from '@/store'



const mainRoutes = [
    {
        path: "/",
        name: "home",
        redirect: "/home",
    },
    {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: {
            title: "首页",
        },
    },
    {
        path: "/search",
        name: "search",
        component: () => import("@/views/search/index"),
        meta: {
            title: "搜索",
        },
    },
    {
        path: "/filmList",
        name: "filmList",
        component: () => import("@/views/filmList/index"),
        meta: {
            title: "影片列表",
        },
    },
    {
        path: "/filmDetail",
        name: "filmDetail",
        component: () => import("@/views/filmDetail/index"),
        meta: {
            title: "影片详情",
        },
    },
    {
        path: "/cinemaList",
        name: "cinemaList",
        component: () => import("@/views/cinemaList/index"),
        meta: {
            title: "影院列表",
        },
    },
    {
        path: "/location",
        name: "location",
        component: () => import("@/views/location/index"),
        meta: {
            title: "选择城市",
        },
    },
    {
        path: "/cinemaDetail",
        name: "cinemaDetail",
        component: () => import("@/views/cinemaDetail/index"),
        meta: {
            title: "影院-场次",
        },
    },
    {
        path: "/seat",
        name: "seat",
        component: () => import("@/views/seat/index"),
        meta: {
            title: "选座",
        },
    },
];

// 消除重复跳转警告
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
    mode: 'hash',
    // base: process.env.VUE_APP_CONTEXT_PATH,
    scrollBehavior: () => ({ y: 0 }),
    base: __dirname,
    routes: mainRoutes,
});

router.beforeEach(async (to, from, next) => {
    if(window.SITE_CONFIG['menuList'].find(item => item.path === to.path)){
        return next()
    }
    await store.dispatch('cinema/getToken')
    await store.dispatch('cinema/getCityList')
    await store.dispatch('city/getLocation')
    window.SITE_CONFIG['menuList'] = mainRoutes
    next();
});

export default router;
